"use strict";

angular.module('PatientApp').factory('ContactService', function (VuexStore) {
  return {
    send: function send(contactInfo) {
      return VuexStore.dispatch('sendContactInfo', contactInfo);
    }
  };
});